import * as React from 'react';
import * as style from './RatingList.css';
import { Loading } from '../Loading';

type ITRatingListProps = {
  agencies: JSX.Element[] | undefined;
  isLoadingRating: boolean;
};

export const RatingList: React.FC<ITRatingListProps> = ({ agencies, isLoadingRating }) => {
  return (
    <div className={style['container']}>
      {isLoadingRating && <Loading />}
      <div className={style['wrapper']}>
        <div className={style['list']}>
          <div className={style['header']}>
            <div>Место</div> <div>Риелторы / Агентства</div> <div>Охват, млн показов</div>
          </div>
          {agencies}
          <div className={style['footer']}></div>
        </div>
      </div>
    </div>
  );
};
